/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { defaultState, defaultWebcast, WebcastReducerInterface, WebcastInterface } from './defaultState'
import { actionTypes } from '../../../actions/src'
import omit from 'lodash/omit'
import { ReduxAction } from '../../reducerType'
import has from 'lodash/has'
import merge from 'lodash/merge'
import format from 'date-fns/format'

const webcastReducer = (state: WebcastReducerInterface = defaultState, { type, payload }: ReduxAction): WebcastReducerInterface => {

  let webcast: WebcastInterface | null = null
  if (payload) {

    if (has(state.collection, payload.identifier)) webcast = state.collection[payload.identifier]
    else webcast = defaultWebcast

  }

  switch (type) {

    case actionTypes.POST_WEBCAST_CREATION:
      return {
        ...state,
        status: {
          ...state.status,
          isPostProcessing: true,
          postProcessingSuccess: false
        }
      }
      // @ts-ignore
    case actionTypes.POST_WEBCAST_CREATION_FAIL:
    case actionTypes.POST_WEBCAST_CREATION_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          isPostProcessing: false,
          postProcessingSuccess: true
        }
      }
    case actionTypes.SUBMIT_WEBCAST:
      return {
        ...state,
        status: {
          ...state.status,
          isSubmitting: true,
          hasError: false,
          submitSuccess: false
        },
        errors: {}
      }
    case actionTypes.SUBMIT_WEBCAST_SUCCESS:
      return {
        ...state,
        collection: {
          ...state.collection,
          [`${payload.channel.id}${payload.id}`]: {
            status: { 
              hasData: true,
              isFetching: false,
              hasError: false
            },
            data: payload
          },
        },
        newWebcastId: payload.id,
        status: {
          ...state.status,
          isSubmitting: false,
          hasError: false,
          submitSuccess: true
        }
      }
    case actionTypes.SUBMIT_WEBCAST_SUCCESS_EDIT:
      return {
        ...state,
        [`${payload.channel.id}${payload.id}`]: {
          status: { hasData: true },
          data: payload
        },
        newWebcastId: null,
        status: {
          ...state.status,
          isSubmitting: false,
          hasError: false,
          submitSuccess: true
        }
      }
    case actionTypes.SUBMIT_WEBCAST_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          hasError: true,
          isSubmitting: false,
          submitSuccess: false
        },
        errors: payload
      }
    case actionTypes.RESET_CREATION:
      return {
        ...state,
        newWebcastId: null,
        status: {
          ...state.status,
          isSubmitting: false,
          hasError: false,
          submitSuccess: false,
          isPostProcessing: false,
          postProcessingSuccess: false
        }
      }
    case actionTypes.CLEAR_SERVER_ERROR:
      return !payload
        ? { ...state, errors: {} }
        : { ...state, errors: omit(state.errors, payload) }
    case actionTypes.FETCH_PUBLIC_WEBCAST_DATA:
    case actionTypes.FETCH_WEBCAST_DATA: {

      if (!webcast || !payload.identifier) return state

      const _webcast = merge({}, webcast, {
        status: {
          hasError: false,
          isFetching: true
        }
      })

      const collection = merge({}, state.collection, {
        [payload.identifier]: _webcast
      })

      return {
        ...state,
        collection
      }

    }
    case actionTypes.FETCH_PUBLIC_WEBCAST_DATA_SUCCESS:
    case actionTypes.FETCH_WEBCAST_DATA_SUCCESS: {

      if (!webcast || !payload.data || !payload.identifier) return state

      const _webcast = merge({}, webcast, {
        data: { ...defaultWebcast.data, ...payload.data, 
          serviced: payload.data.serviced === 'true' ? true : false 
        },
        status: {
          hasData: true,
          hasError: false,
          isFetching: false
        }
      })

      const collection = merge({}, state.collection, {
        [payload.identifier]: _webcast
      })

      return {
        ...state,
        collection
      }

    }
    case actionTypes.FETCH_PUBLIC_WEBCAST_DATA_ERROR:
    case actionTypes.FETCH_WEBCAST_DATA_ERROR:
    case actionTypes.FETCH_WEBCAST_DATA_FORBIDDEN: {

      if (!webcast || !payload.data || !payload.identifier) return state

      const _webcast = merge({}, webcast, {
        data: payload.data,
        status: {
          hasData: false,
          hasError: true,
          isFetching: false
        }
      })

      const collection = merge({}, state.collection, {
        [payload.identifier]: _webcast
      })

      return {
        ...state,
        collection
      }

    }
    case actionTypes.CANCEL_WEBCAST:
      return {
        ...state,
        status: {
          ...state.status,
          isSubmitting: true,
          hasError: false,
          submitSuccess: false
        },
        errors: {}
      }
    case actionTypes.CANCEL_WEBCAST_SUCCESS: {
      const collection = merge({}, state.collection, {
        [`${payload.channel.id}${payload.id}`]: {
          status: { hasData: true },
          data: payload
        }
      })
      return {
        ...state,
        collection,
        status: {
          ...state.status,
          isSubmitting: false,
          hasError: false,
          submitSuccess: true
        }
      }
    }
    case actionTypes.CANCEL_WEBCAST_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          hasError: true,
          isSubmitting: false,
          submitSuccess: false
        },
        errors: payload
      }
    case actionTypes.UPDATE_WEBCAST_STATUS:
      return {
        ...state,
        collection: {
          ...state.collection,
          [`${payload.channelId}${payload.webcastId}`]: {
            ...state.collection[`${payload.channelId}${payload.webcastId}`],
            data: {
              ...state.collection[`${payload.channelId}${payload.webcastId}`].data,
              status: payload.status,
              lastUpdated: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss'Z")
            }
          }
        }
      }
    default:
      return state

  }

}

export default webcastReducer
